import {Action} from "redux";
import { IClientSalesCampaignActionCreator } from "../action/client_sales_campaign";
import { GetCustomersBySalesCampaignPageRequest } from "../request/customer_request";

interface IClientSalesCampaignDispatcher {
    getCustomers(item: GetCustomersBySalesCampaignPageRequest): void;
}

class Dispatcher implements IClientSalesCampaignDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientSalesCampaignActionCreator) {

    }

    public getCustomers = (item: GetCustomersBySalesCampaignPageRequest) => {
        this.dispatch(this.actionCreator.requestGetCustomerByClientSalesCampaignPageAction(item));
    }

}

const createClientSalesCampaignDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientSalesCampaignActionCreator): IClientSalesCampaignDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientSalesCampaignDispatcher, createClientSalesCampaignDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_sales_campaign.ts